import { Scroll } from 'common/components/base/scroll';
import styled from 'styled-components';

const ContentScroll = styled(Scroll)`
    overflow-y: auto;
    height: calc(100% - 56px);
`;

export { ContentScroll };
